import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getAllIP_INV = () => {
    return httpClient.get(server.IP_INV + `/`);
};

export const CreateIP_INV = (data) => {
    return httpClient.post(server.IP_INV, data);
};

export const updateIP_INV = (id, data) => {
    return httpClient.put(server.IP_INV + `/${id}`, data);
};


export const DeleteIP_INV = (id) => {
    return httpClient.delete(server.IP_INV + `/${id}`);
};
